import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 15h3a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h3","key":"svg-0"}],["path",{"d":"M5 12h14","key":"svg-1"}],["path",{"d":"M9 3l6 6","key":"svg-2"}],["path",{"d":"M9 9l6 -6","key":"svg-3"}]]

const IconMathXDivide2 = createReactComponent('outline', 'math-x-divide-2', 'MathXDivide2', __iconNode);

export default IconMathXDivide2;